import React from 'react';

import { NavIconWithPopover, Flex } from 'src/packages/core';
import { HeaderRightPart } from '../Header.styles';
import { ThemeType } from 'src/packages/theme';
import {
  DownloadIcon,
  GlobeIcon,
  NotificationIcon,
  NotificationNewIcon,
  SearchIcon,
  ThemeDarkIcon,
  ThemeLightIcon,
} from '../../../icons';
import { SearchIconContent } from './SearchIconContent';
import { HeaderButtons } from './HeaderButtons';
import { DownloadIconPopoverContent } from './DownloadIconPopoverContent';
import { NotificationIconPopoverContent } from './NotificationIconPopoverContent';
import { GlobeIconPopoverContent } from './GlobeIconPopoverContent';
import {
  HeaderAssets,
  HeaderUser,
  KycAndFeaturesConfig,
  QuickSearchDataType,
  IconToExcludeType,
  Announcement,
  HeaderNotifications,
  Locale,
  AppTheme,
} from '../Header.types';

interface Props {
  quickSearchData?: QuickSearchDataType;
  kycAndFeaturesConfig?: KycAndFeaturesConfig;
  theme?: ThemeType;
  user?: HeaderUser;
  userLoading: boolean;
  hideRightNav?: boolean;
  assets?: HeaderAssets;
  logout?: () => void;
  copyToClipboard?: (value: string) => void;
  shouldHideIcon: (icon: IconToExcludeType) => boolean;
  announcements: Announcement[];
  notifications?: HeaderNotifications;
  locale: Locale;
  appTheme?: AppTheme;
}

export const HeaderRightPartWrapper = ({
  quickSearchData,
  theme = 'dark',
  kycAndFeaturesConfig,
  user,
  userLoading,
  hideRightNav,
  assets,
  logout,
  copyToClipboard,
  shouldHideIcon,
  notifications,
  announcements,
  locale,
  appTheme,
}: Props) => {
  return (
    <HeaderRightPart>
      {quickSearchData && (
        <NavIconWithPopover
          icon={SearchIcon}
          popoverCustomContent={
            <SearchIconContent
              theme={theme}
              quickSearchData={quickSearchData}
              kycAndFeaturesConfig={kycAndFeaturesConfig}
            />
          }
          theme={theme}
        />
      )}

      <HeaderButtons
        user={user}
        userLoading={userLoading}
        hideRightNav={hideRightNav}
        assets={assets}
        theme={theme}
        logout={logout}
        copyToClipboard={copyToClipboard}
        kycAndFeaturesConfig={kycAndFeaturesConfig}
      />

      {!shouldHideIcon('download') && (
        <NavIconWithPopover
          icon={DownloadIcon}
          popoverCustomContent={<DownloadIconPopoverContent theme={theme} />}
          theme={theme}
        />
      )}

      {!shouldHideIcon('notifications') && (
        <NavIconWithPopover
          icon={notifications && notifications.unread > 0 ? NotificationNewIcon : NotificationIcon}
          popoverCustomContent={
            <NotificationIconPopoverContent
              theme={theme}
              announcements={announcements}
              notifications={notifications}
            />
          }
          theme={theme}
        />
      )}

      {!shouldHideIcon('language') && (
        <NavIconWithPopover
          icon={GlobeIcon}
          popoverCustomContent={<GlobeIconPopoverContent theme={theme} locale={locale} />}
          theme={theme}
        />
      )}
      {appTheme && (
        <Flex onClick={appTheme.changeTheme}>
          <NavIconWithPopover
            icon={appTheme.theme === 'dark' ? ThemeLightIcon : ThemeDarkIcon}
            noPopover={true}
            theme={theme}
          />
        </Flex>
      )}
    </HeaderRightPart>
  );
};
